// Google Analytics (GA4) for the web app via gtag.js.
//
// Enabled when VITE_GA_MEASUREMENT_ID is set; otherwise every function here is a
// no-op and no analytics script is loaded (local dev, PR builds, staging).

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

const gtagEnabled = Boolean(GA_MEASUREMENT_ID);

let initialized = false;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

function gtag(...args: unknown[]): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

export function analyticsEnabled(): boolean {
  return gtagEnabled;
}

export function initAnalytics(): void {
  if (!gtagEnabled) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag('js', new Date());
  // We emit page_view manually on route changes, so disable the automatic one.
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
  initialized = true;
}

/** Log a GA4 page_view. No-op until analytics is initialized. */
export function trackPageView(path: string, title?: string): void {
  if (!initialized) return;
  gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title ?? document.title,
  });
}

/** Log a named GA4 event with optional params. No-op until initialized. */
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (!initialized) return;
  gtag('event', name, params ?? {});
}
